import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19__2ca2db9a3b329ee59e005e1cefb27129/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}